function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-elecCompteur");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-elecCompteur"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(3.000000, 3.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})), /*#__PURE__*/React.createElement("path", {
  d: "M27,3 L27,27 L3,27 L3,3 L27,3 Z M19.5,6 L10.5,6 C9.67157288,6 9,6.67157288 9,7.5 L9,7.5 L9,22.5 C9,23.3284271 9.67157288,24 10.5,24 L10.5,24 L19.5,24 C20.3284271,24 21,23.3284271 21,22.5 L21,22.5 L21,7.5 C21,6.67157288 20.3284271,6 19.5,6 L19.5,6 Z M13,17 C13.5522847,17 14,17.4477153 14,18 C14,18.5522847 13.5522847,19 13,19 C12.4477153,19 12,18.5522847 12,18 C12,17.4477153 12.4477153,17 13,17 Z M17,17 C17.5522847,17 18,17.4477153 18,18 C18,18.5522847 17.5522847,19 17,19 C16.4477153,19 16,18.5522847 16,18 C16,17.4477153 16.4477153,17 17,17 Z M18,12 L18,15 L12,15 L12,12 L18,12 Z",
  id: "Combined-Shape",
  fill: "#D93252"
})));

const SvgIco30ElecCompteur = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ElecCompteur, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-elecCompteur.802757b3.svg";
export { ForwardRef as ReactComponent };